import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    noResults: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      background: theme.palette.background.paper,
    },
    container: {
      marginTop: theme.spacing(-2),
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    chartWrapper: {
      height: 175,
      width: 175,
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(4),
      },
      [theme.breakpoints.up('md')]: {
        marginRight: theme.spacing(7),
      },
    },
    legendWrapper: {
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(1),
      },
    },
    legend: {
      overflow: 'hidden',
    },
    legendRow: {
      lineHeight: '28px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    colorIcon: {
      backgroundColor: 'gray',
      height: 16,
      width: 16,
      marginRight: theme.spacing(2),
      display: 'inline-block',
      verticalAlign: 'middle',
    },
    legendText: {
      verticalAlign: 'middle',
    },
  })
);
